import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, History } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const dataFormatata = (iso) => new Date(iso).toLocaleDateString("ro-RO", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

const ACTIUNI_LABEL = {
  delete_user: "a șters contul",
  grant_premium: "a acordat Premium către",
  revoke_premium: "a retras Premium de la",
  create_announcement: "a publicat un anunț",
  clear_announcement: "a retras anunțul",
  create_promo_code: "a creat codul promo",
  deactivate_promo_code: "a dezactivat codul promo",
  retry_failed_email: "a retrimis email către",
  trigger_renewal_reminders: "a rulat manual reamintirile de reînnoire",
  trigger_debt_reminders: "a rulat manual reamintirile de datorii",
};

// Tab „Jurnal": istoricul acțiunilor de admin (transparență între fondatori).
export function AuditLogPanel() {
  const [entries, setEntries] = useState(null);
  const [eroare, setEroare] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/admin/audit-log`, { withCredentials: true })
      .then((r) => setEntries(r.data.entries))
      .catch(() => setEroare("Nu am putut încărca jurnalul."));
  }, []);

  if (eroare) return <p className="text-center text-rose-500 py-10">{eroare}</p>;
  if (!entries) return <Loader2 className="h-6 w-6 animate-spin text-emerald-600 mx-auto mt-10" />;

  return (
    <div className="space-y-2" data-testid="audit-log-panel">
      {entries.length === 0 ? (
        <p className="text-center text-slate-400 text-sm py-8">Nicio acțiune înregistrată încă.</p>
      ) : (
        entries.map((e) => (
          <div key={e.id} data-testid={`audit-row-${e.id}`} className="rounded-2xl bg-white border border-slate-100 shadow-sm p-3 flex items-start gap-2.5">
            <History className="h-4 w-4 text-slate-300 shrink-0 mt-0.5" />
            <div className="min-w-0 flex-1">
              <p className="text-sm text-slate-700">
                <span className="font-semibold">{e.admin_email}</span> {ACTIUNI_LABEL[e.action] || e.action}
                {e.target ? <span className="font-semibold"> {e.target}</span> : ""}
              </p>
              <p className="text-[11px] text-slate-400 mt-0.5">{dataFormatata(e.created_at)}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
